import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, QueryList, signal, ViewChildren, WritableSignal } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MessageService, ConfirmationService } from 'primeng/api';
import { JobServicesService } from 'src/app/services/job-services.service';
import { EmailServicesService } from 'src/app/services/email-services.service';
import { GlobalServicesService } from 'src/app/services/global-services.service';
import { FileUploadService } from 'src/app/services/file-upload.service';
import { BreadcrumbService   } from 'xng-breadcrumb';
import { HttpResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Subject, takeUntil } from 'rxjs';
import { Popover } from 'primeng/popover';

declare let tinymce: any;
export interface TemplateList {
  category: string;
  categoryId: string;
  id: string;
  isEditable: boolean;
  templateTitle: string;
  subjectTitle: string;
  templateContent: any;
  collapse: boolean;
  showIcons: boolean;
  is_default?: boolean;
}

export enum Placeholders {
  User = ' ${User} ',
  UserId = ' ${UserId} ',
  EmailId = ' ${EmailId} ',
  UserType = ' ${UserType} ',
  Address = ' ${Address} ',
  SchoolName = ' ${SchoolName} ',
  ContactNumber = ' ${ContactNumber} ',
  Email_Signature = ' ${Email_Signature} ',
  Emails = ' ${Emails} ',
  Test_Link = ' ${Test_Link} ',
  Interview_Link = ' ${Interview_Link} ',
  Stage_Name = ' ${Stage_Name} ',
  Job_Name = ' ${Job_Name} ',
  Stage_Type = ' ${Stage_Type} ',
  Documents_Link = ' ${Documents_Link} ',
  SupportLink = ' ${SupportLink} ',
  Link = ' ${Link} ',
  Test_Name = ' ${Test_Name} ',
  Contest_Name = ' ${Contest_Name} ',
  Role_Name = ' ${Role_Name} ',
  offerConfirmationLink = ' ${offerConfirmationLink} ',
  cohortJobRole = ' ${cohortJobRole} ',
  cohortSpoc = ' ${cohortSpoc} ',
  cohortLocation = ' ${cohortLocation} ',
  cohortId = ' ${cohortId} ',
  cohortDate = ' ${cohortDate} ',
  OfferCohortDeadline = ' ${OfferCohortDeadline} ',
  DocumentCohortJobRole = ' ${DocumentCohortJobRole} ',
  DocumentCohortPOC = ' ${DocumentCohortPOC} ',
  DocumentCohortLocation = ' ${DocumentCohortLocation} ',
  DocumentCohortDeadline = ' ${DocumentCohortDeadline} ',
}

@Component({
    selector: 'app-email-template',
    templateUrl: './email-template.component.html',
    styleUrls: ['./email-template.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class EmailTemplateComponent implements OnInit, OnDestroy {
  unsub$: Subject<void> = new Subject<void>();

  tinymce_api_key = environment.HOST.TINYMCE_API_KEY;
  categories: Array<any> = [];
  templateList: Array<TemplateList> = [];
  _templateList: Array<TemplateList> = [];
  addTemplateSidebar: boolean = false;
  newCategoryName: string = '';
  isLoading: boolean = true;
  selectedCategoryId: string = '';
  categoryRename: string = '';
  showPlaceholder: boolean = false;
  placeholders: Array<any> = [];
  focusedElement: any;
  cursorPositionId: string = '';
  cursor: Array<number> = [];
  userPrivileges: Set<string> = new Set();

  _subjectTitle: string = '';
  _templateContent: string = '';
  _selectedCategory: any;
  _filteredCategory: any;
  _templateTitle: string = '';
  templateToEdit: string = '';
  saveBtnLoading: boolean = false;
  isAllActive: boolean = true;
  clicked: boolean = false;
  privilege: any = {};
  schoolId: string = '';
  templateSearchTerm: string = '';

  addTemplateForm: FormGroup = new FormGroup({
    category: new FormControl(''),
    templateTitle: new FormControl('', [Validators.required]),
    subjectTitle: new FormControl('', [Validators.required]),
    templateContent: new FormControl(),
  });

  openedTemplate: WritableSignal<TemplateList | null> = signal<TemplateList | null>(null);
  editingTemplate: WritableSignal<boolean> = signal<boolean>(false);
  editingTemplateName: string = "";
  editingTemplateCategory: any = null;
  editingTemplateSubject: string = "";
  disableSaveChanges: WritableSignal<boolean> = signal<boolean>(true);
  @Input() createNewTemplate$!: Subject<void>; 

  loadingTemplateDetails: boolean = false
  @ViewChildren(Popover) popovers: QueryList<Popover> | undefined;

  constructor(
    private jobServices: JobServicesService,
    private emailServices: EmailServicesService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private globalService: GlobalServicesService,
    private fileUploadService: FileUploadService,
    private breadcrumbService: BreadcrumbService,
    private cdr: ChangeDetectorRef
  ) {  }

  ngOnInit(): void {
    this.globalService.privilegeDetailsSubject.subscribe((privileges) => {
      this.userPrivileges = privileges;
    });    
    if (
      this.userPrivileges.has('email_category.create') ||
      this.userPrivileges.has('email_category.view')
    ) {
      this.getCategories();
    }
    else {
      this.getEmailTemplates();
    }
  
    this.privilege = this.globalService.privilegeDetails;
    this.schoolId = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details') || '{}').company_settings?.school_code : '';

    this.createNewTemplate$.pipe(takeUntil(this.unsub$)).subscribe((res) => {
      this.openAddTemplate()
    })
  }

  ngOnDestroy(): void {
    this.unsub$.next();
    this.unsub$.complete();
  }
  

  emailTemplateFormData = (categoryId: string) => {
    this.emailServices.getEmailTemplateFormDataFastApi(categoryId).subscribe({
      next: (response) => {
        if (response.status === 200) {
          const data = response.body;
          const placeholderList = Array.isArray(data) && data.length > 0 
            ? data[0].placeholders 
            : [];
          this.placeholders = placeholderList.map((placeholder: string) => ({
            value: ` \${${placeholder}} `,
            tag: placeholder,
          }));
        }
      },
      error: (_err) => { }
    });
  }
  getCategories = (renameId?:any,isDeleted?: boolean) => {
    this.isLoading = true;
    this.emailServices.getEmailCategoriesFastApi().subscribe({
      next: (response) => {
        if (response.status === 200) {
          let categories = response.body.items ? response.body.items : [];
          this.categories = categories.map((category: any) => ({
            name: category.name,
            id: category.id,
            isActive: renameId === category.id,
            isRenameCategory: false,
            is_default: category.is_default ?? false,
          }));
        }
        this.isLoading = false;
      },
      error: (_err) => {
        this.isLoading = false;
      }
    });
    if(isDeleted){
      this.isAllActive = true;
    }
    this.getEmailTemplates();
  };

  getEmailTemplates = () => {
    this.isLoading = true;
    this.emailServices.getTemplatesFastApi(this.isAllActive ? '' : this.selectedCategoryId).subscribe({
      next: (response) => {
        if (response.status === 200) {
          let templateList = response.body.email_templates ? response.body.email_templates : [];
          this.templateList = templateList.map((item: any) => ({
            category: item.category,
            categoryId: item.categoryId,
            id: item.id,
            isEditable: item.is_editable,
            templateTitle: item.name,
            subjectTitle: item.subjectTitle,
            templateContent: item.templateContent,
            collapse: true,
            showIcons: false,
            is_default: item.is_default,
          }));
          this._templateList = this.templateList;

          this.openedTemplate.set(this.openedTemplate() ? this.openedTemplate() : null);
          this.editingTemplate.set(false);
          if(this._templateList.length) {
            this.openTemplate(this.openedTemplate() ? this.openedTemplate()! : this._templateList[0]);
          }
        }
        this.isLoading = false;
      },
      error: (_err) => {
        this.isLoading = false;
      }
    });
  };
  openCategory = (name: string) => {
    this.isLoading = true;
    this.isAllActive = false;
    if (name === 'All') {
      this.isAllActive = true;
      this.categories.forEach((val: any) => (val.isActive = false));
      this.selectedCategoryId = '';
      this._selectedCategory = '';
    } else {
      this.categories.forEach((val: any) => {
        if (val.name === name) {
          val.isActive = true;
          this.selectedCategoryId = val.id;
          this._selectedCategory = val;
        } else {
          val.isActive = false;
          this.isAllActive = false;
        }
      });
    }
    this.openedTemplate.set(null);
    this.getEmailTemplates();
  };

  addCategory = (ip: any) => {
    if (this.newCategoryName) {
      const categoryExists = this.categories.some(category => category.name.toLowerCase() === this.newCategoryName.toLowerCase());
      if (categoryExists) {
        this.messageService.add({
          severity: 'warn',
          summary: 'Warning',
          detail: 'Category already exists!'
        });
        return;
      }
      this.isLoading = true;
      let payload = { name: this.newCategoryName };
      this.emailServices.createEmailCategoryFastApi(payload).subscribe({
        next: (response) => {
          if (response.status === 201) {
            this.emailServices.getEmailCategoriesFastApi().subscribe({
              next: (res) => {
                let categories = res.body.items ? res.body.items : [];
                this.categories = categories.map((category: any) => ({
                  name: category.name,
                  id: category.id,
                  isActive: false,
                  isRenameCategory: false,
                  is_default: category.is_default ?? false,
                }));
                ip.deactivate();
                this.categories[this.categories.length - 1].isActive = true;
                this.newCategoryName = '';
                this.isLoading = false;
                this.isAllActive = false;
                this.selectedCategoryId = this.categories[this.categories.length - 1].id;
                this.openedTemplate.set(null);
                this.getEmailTemplates();
              },
              error: (err) => {
                console.error('Error fetching categories:', err);
                this.isLoading = false;
              }
            });
          }
        },
        error: (_err) => {
          this.isLoading = false;
        }
      });
    }
  };
  openPanel(template: TemplateList){
    this.getSpecificTemplateData(template);
  }

  async getSpecificTemplateData(template: TemplateList): Promise<void> {
    this.loadingTemplateDetails = true;
    if (template.id) {
      return new Promise((resolve, reject) => {
        this.emailServices.getSpecificTemplateFastApi(template.id).subscribe({
          next: (response) => {
            if (response.status === 200) {
              template.subjectTitle = response.body.subject;
              template.templateContent = response.body.body;
              template.is_default = response.body.is_default;
              this.selectedCategoryId = response.body.email_category_id;

              this.editingTemplateSubject = template.subjectTitle;
              this.editingTemplateCategory = this.selectedCategoryId;
              resolve();
              this.loadingTemplateDetails = false;
            }
          },
          error: (err) => {
            reject(new Error('Error fetching specific template: ' + err));
            this.loadingTemplateDetails = false;
          }
        });
      });
    }
  }

  searchTemplate() {
    this._templateList = this.templateList.filter(val => val.templateTitle.toLowerCase().includes(this.templateSearchTerm.toLowerCase()));
  }

  dataURItoBlob(dataURI: any, type: any) {
    dataURI = dataURI.split('" ')[0];
    const binary = atob(dataURI.split(',')[1]);
    const array = [];
    for (let i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i));
    }
    return new Blob([new Uint8Array(array)], { type: type });
  }

  saveTemplate = async () => {
    this.clicked = true;
    if (this.addTemplateForm.valid) {
      this.saveBtnLoading = true;
      let newTemplate = this.addTemplateForm.value;
      let editorText = (typeof tinymce !== 'undefined' && tinymce.get(0)) 
        ? tinymce.get(0).getContent()
        : null;
      this.addTemplateForm.controls['templateContent'].setValue(editorText);

      let payload = {
        email_category_id: newTemplate.category,
        name: newTemplate.templateTitle,
        subject: newTemplate.subjectTitle,
        body: (typeof tinymce !== 'undefined' && tinymce.get(0))
          ? tinymce.get(0).getContent()
          : null
      };
      this.clicked = false;
      if (this.templateToEdit) {
        this.emailServices.updateTemplateFastApi(payload, this.templateToEdit).subscribe({
          next: (response) => {
            this.handleTemplateResponse(response, 'Template Edited Successfully', 'Unable to Edit the template', 200);
          },
          error: (_err) => {
            this.saveBtnLoading = false;
          }
        });
      } else {
        this.emailServices.createTemplateFastApi(payload).subscribe({
          next: (response) => {
            this.handleTemplateResponse(response, 'Template Created Successfully', 'Unable to create the template', 201);
          },
          error: (_err) => {
            this.saveBtnLoading = false;
          }
        });
      }
    }
  };
  handleTemplateResponse = (response: HttpResponse<any>, successMessage: string, errorMessage: string, successStatusCode: number) => {
    if (response.status === successStatusCode) {
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: successMessage,
      });
      this.addTemplateForm.reset();
      this.getEmailTemplates();
      this.templateToEdit = '';
      this.addTemplateSidebar = false;
    } 
    this.saveBtnLoading = false;
  };

  async editTemplate(template: TemplateList) {
    await this.getSpecificTemplateData(template);
    this._filteredCategory = this.categories.filter(
      (item: any) => item.id === this.selectedCategoryId
    )[0];
    this._selectedCategory = this._filteredCategory;
    this._templateTitle = template.templateTitle;
    this._subjectTitle = template.subjectTitle;
    this._templateContent = template.templateContent;
    this.templateToEdit = template.id;
    this.openAddTemplate(template);
    // Remove the immediate setContent call as it's now handled in loadTinyMce
}

  deleteTemplate(template: TemplateList, event: any) {
    this.confirmationService.confirm({
      target: event.target,
      message: 'Are you sure that you want to proceed?',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.emailServices.deleteTemplateFastApi(template.id).subscribe({
          next: (response) => {
            if (response.status === 200) {
              this.openedTemplate.set(null);
              this.getEmailTemplates();
              this.messageService.add({
                severity: 'info',
                summary: 'Deleted',
                detail: 'Template deleted',
              });
            }
          },
          error: (err) => {
            console.error('Error deleting specific template:', err);
          }
        });
      },
      reject: () => {
        // this.messageService.add({
        //   severity: 'error',
        //   summary: 'Rejected',
        //   detail: 'You have rejected',
        // });
      },
    });
  }

  getElement = (id: string) => {
    this.cursorPositionId = id;
    this.focusedElement = document.getElementById(id);
    if (this.cursorPositionId === 'title') {
      let [start, end] = [
        this.focusedElement.selectionStart,
        this.focusedElement.selectionEnd,
      ];
      this.cursor = [start, end];
    }
  };

  removeFocus() {
    this.focusedElement = null;
    this.cursorPositionId = '';
  }

  insertPlaceholder = (text: string) => {
    if (this.cursorPositionId === 'title') {
      let currentValue = this.focusedElement?.value;
      let patchedValue =
        currentValue.substring(0, this.cursor[0]) +
        text +
        currentValue.substring(this.cursor[1]);
      this._subjectTitle = patchedValue;
    }

    // Check if TinyMCE is loaded and activeEditor exists before inserting content
    if (typeof tinymce !== 'undefined' && tinymce.activeEditor) {
      tinymce.activeEditor.insertContent(text);
    }
  };

  Clear = () => {
    this.addTemplateForm.reset();
    this.globalService.removeScript();
    // this.selectedCategoryId = '';
    this._templateTitle = '';
    this._subjectTitle = '';
    this.placeholders = [];
    this.loadTinyMce();
    // Remove the immediate check for tinymce.activeEditor as it might not be loaded yet
    // The content will be cleared when TinyMCE is initialized
  };

  onSave() { }

  async loadTinyMce(template?: any) {
    await this.globalService.loadScript(
      'script',
      `https://cdn.tiny.cloud/1/${this.tinymce_api_key}/tinymce/8.0.2/tinymce.min.js`,
      'text/javascript',
      'examlyck'
    );
    tinymce.remove();
    tinymce
      .init({
        selector: 'textarea',
        content_style: "@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600&display=swap'); body { font-family: Poppins; }",
        height: 500,
        content_css_cors: true,
        content_css: true,
        menubar: 'file edit view insert format tools table help',
        plugins: 'preview searchreplace autolink directionality code visualblocks visualchars fullscreen link media codesample table charmap pagebreak nonbreaking anchor insertdatetime advlist lists wordcount help quickbars emoticons save autoresize image',
        toolbar: 'undo redo | bold italic underline strikethrough | fontfamily fontsize blocks | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media link anchor codesample | ltr rtl',
        toolbar_sticky: true,
        toolbar_mode: 'wrap',
        paste_data_images: true,
        image_caption: true,
        image_title: true,
        automatic_uploads: true,
        file_picker_types: 'image',
        images_upload_handler: (blobInfo: any): Promise<string> => {
          return new Promise((resolve, reject) => {
            const blob = blobInfo.blob();
            if (!this.schoolId) { reject({ message: 'Upload failed: missing tenant ID', remove: true }); return; }
            const originalName = blobInfo.filename() || `image_${Date.now()}.png`;
            const nameParts = originalName.split('.');
            const ext = nameParts.pop();
            const safeExt = ext ? `.${ext}` : '.png';
            const safeName = `${nameParts.join('').replace(/[^\w]/g, '')}_${Date.now()}${safeExt}`;
            const file = new File([blob], safeName, { type: blob.type });
            const filePath = `temp/${this.schoolId}/${safeName}`;

            this.fileUploadService.getSignedUrlGCS({ file_path: filePath, bucket_type: 'public', origin: 'email_template' }).subscribe({
              next: (response: any) => {
                const signedUrl = response?.body?.signed_url;
                if (!signedUrl) { reject({ message: 'Failed to get upload URL', remove: true }); return; }
                this.fileUploadService.uploadUsingSignedUrlGCS(signedUrl, file).subscribe({
                  next: (event: any) => {
                    if (event?.status === 'success') {
                      resolve(signedUrl.split('?')[0]);
                    }
                  },
                  error: () => reject({ message: 'Image upload failed', remove: true })
                });
              },
              error: () => reject({ message: 'Failed to get upload URL', remove: true })
            });
          });
        },
        quickbars_selection_toolbar: 'bold italic | quicklink h2 h3 blockquote quickimage quicktable',
        quickbars_insert_toolbar: 'quickimage quicktable',
        noneditable_noneditable_class: 'mceNonEditable',
        contextmenu: 'link image imagetools table',
        relative_urls: false,
        convert_urls: false,
        branding: false,
        deprecation_warnings: false,
        paste_as_text: false,
        paste_auto_cleanup_on_paste: true,
        textpattern_patterns: [
          {start: '*', end: '*', format: 'italic'},
          {start: '**', end: '**', format: 'bold'},
          {start: '#', format: 'h1'},
          {start: '##', format: 'h2'},
          {start: '###', format: 'h3'},
          {start: '1. ', cmd: 'InsertOrderedList'},
          {start: '* ', cmd: 'InsertUnorderedList'},
          {start: '- ', cmd: 'InsertUnorderedList'}
        ],
        min_height: 500,
        max_height: 500,
        autoresize_bottom_margin: 0,
        autoresize_overflow_padding: 0,
        setup: (editor: any) => {
          editor.on('init', () => {
            if (template && template.templateContent) {
              editor.setContent(template.templateContent);
            }
          });
          editor.on('change keyup', () => {
            const content = editor.getContent();
            this.addTemplateForm.patchValue({ templateContent: content });
            this.disableSaveChanges.set(false)
          });
        }
      })
      .catch((error: any) => {
        console.error('TinyMCE initialization failed:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Editor Error',
          detail: 'Failed to initialize the rich text editor. Please refresh and try again.'
        });
      });
  }

  openAddTemplate(template?: any) {
    this.showPlaceholder = false;
    if (!template) {
      this.Clear();
    }
    this.addTemplateSidebar = true;
    this.clicked = false;
    this._filteredCategory = this.categories.filter(
      (item: any) => item.id === this.selectedCategoryId
    )[0];
    this._selectedCategory = this._filteredCategory;
    if (this._selectedCategory?.id) {
      this.addTemplateForm.patchValue({ "category": this._selectedCategory.id });
      this.emailTemplateFormData(this._selectedCategory.id);
    }
    this.globalService.removeScript();
    // Add a small delay to ensure DOM is ready
    setTimeout(() => {
      this.loadTinyMce(template);
    }, 100);
  }
  deleteCategory = (category: any,event:any) => {
    this.confirmationService.confirm({
      target: event.target,
      message: 'Are you sure that you want to proceed?',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.isLoading = true;
        this.emailServices.deleteEmailCategoryFastApi(category.id).subscribe({
          next: (response) => {
            if (response.status === 200) {
              this.getCategories(undefined,true);
              this.messageService.add({
                severity: 'info',
                summary: 'Deleted',
                detail: 'Category deleted',
              });
            }
          },
          error: (err) => {
            this.isLoading = false;
            console.error('Error deleting category:', err);
          }
        });
      },
      reject: () => {
        // this.messageService.add({
        //   severity: 'error',
        //   summary: 'Rejected',
        //   detail: 'You have rejected',
        // });
      },
    });
  };
  renameCategory = (category: any) => {
    if (this.categoryRename) {
      const categoryExists = this.categories.some(category => category.name.toLowerCase() === this.categoryRename.toLowerCase());
      if (categoryExists) {
        this.messageService.add({
          severity: 'warn',
          summary: 'Warning',
          detail: 'Category already exists!'
        });
        return;
      }
      this.isLoading = true;
      let payload : any = { name: this.categoryRename };
      this.emailServices.updateEmailCategoryFastApi( payload,category.id).subscribe({
        next: (response) => {
          if (response.status === 200) {
            this.getCategories(category.id);
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: 'Category renamed successfully',
            });
          }
        },
        error: (err) => {
          this.isLoading = false;
          console.error('Error renaming category:', err);
        }
      });
    }
  }

  openTemplate(template: TemplateList) {
    this.showPlaceholder = false;
    this.loadingTemplateDetails = true;
    this.disableSaveChanges.set(true);
    this.editingTemplate.set(false);
    this.openedTemplate.set(null);

    setTimeout(() => {
      this.openedTemplate.set(template);
      this.openPanel(this.openedTemplate()!);
      
      this.editingTemplateName = this.openedTemplate()?.templateTitle ?? "";
      this.editingTemplateCategory = this.selectedCategoryId ?? "";
      this.editingTemplateSubject = this.openedTemplate()?.subjectTitle ?? "";
    }, 100);
  }

  editOpenedTemplate(val: boolean) {
    this.showPlaceholder = false;
    this.editingTemplate.set(val);
    if (val && this.editingTemplateCategory) {
      this.emailTemplateFormData(this.editingTemplateCategory);
    }
    setTimeout(() => {
      this.loadTinyMce(this.openedTemplate()!);
      // tinymce.activeEditor.setContent(this.openedTemplate()!.templateContent);
    }, 0);
  }

  updateTemplate = async () => {
    this.clicked = true;
    if (this.editingTemplateSubject && this.editingTemplateName && this.openedTemplate()) {
      this.saveBtnLoading = true;

      let payload = {
        email_category_id: this.editingTemplateCategory,
        name: this.editingTemplateName,
        subject: this.editingTemplateSubject,
        body: (typeof tinymce !== 'undefined' && tinymce.get(0) && this.editingTemplate())
          ? tinymce.get(0).getContent()
          : this.openedTemplate()?.templateContent
      };
      this.editOpenedTemplate(false);
      this.emailServices.updateTemplateFastApi(payload, this.openedTemplate()!.id).subscribe({
        next: (response) => {
          this.handleTemplateResponse(response, 'Template Edited Successfully', 'Unable to Edit the template', 200);
        },
        error: (_err) => {
          this.saveBtnLoading = false;
        }
      });
    }
  };

  togglePanel(event: Event, panelToOpen: Popover) {
    this.cdr.detectChanges()

    this.popovers?.forEach(panel => {
        if (panel !== panelToOpen) {
            panel.hide();
        }
    });

    setTimeout(() => {
        panelToOpen.toggle(event);
    });
  }

  onDialogCategoryChange(categoryId: string) {
    if (categoryId) {
      this.emailTemplateFormData(categoryId);
    }
  }
}
